import React from 'react';
import {
    disableBuildInfo,
} from '~spa/Utils/BuildInfo';
import {
    useIsBuildInfoEnabled,
    usePageCorrelationId,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useClientVersion,
} from '~shared/hooks/useClientVersion';


const BuildInfoEntry = () => {
    const isBuildInfoEnabled = useIsBuildInfoEnabled();
    if (!isBuildInfoEnabled) {
        return null;
    }

    return <BuildInfo />;
};

const BuildInfo = () => {
    const {
        checkError,
        checkPending,
        checkSuccess,
        clientVersion,
        newClientVersion,
    } = useClientVersion();

    const pageCorrelationId = usePageCorrelationId();

    const OK = '#8bc34a';
    const WARNING = '#ff9800';
    const ERROR = '#f44336';

    const styles = {
        div: {
            background: '#000',
            color: '#999',
            padding: '8px',
            fontSize: '12.8px',
        },
        span: {
            display: 'block',
            marginTop: '8px',
            padding: '8px',
            textAlign: 'center',
            border: '1px solid rgba(255,255,255,0.2)',
        },
        dt: {
            marginTop: '3.2px',
        },
        dd: {
            fontFamily: 'monospace',
            marginLeft: '16px',
            color: '#fff',
        },
    };

    const data = [
        {
            label: `Client Version ${checkPending ? '(checking for updates...)' : ''}`,
            value: clientVersion,
            customStyle: (
                !checkPending && {
                    color: (
                        checkSuccess && !newClientVersion ? OK : WARNING
                        ||
                        checkError && ERROR
                    ),
                }
            ),
        },
    ];

    if (newClientVersion) {
        data.push({
            label: 'New Client Version available',
            value: newClientVersion,
            customStyle: {
                color: OK,
            },
        });
    }

    data.push({
        label: 'Page Correlation Id',
        value: pageCorrelationId,
        customStyle: {},
    });

    return (
        <div style={styles.div}>
            <dl>
                {data.map(({label, value, customStyle}) => (
                    <React.Fragment key={label}>
                        <dt style={styles.dt}>
                            {label}
                        </dt>
                        <dd style={{...styles.dd, ...customStyle}}>
                            {value}
                        </dd>
                    </React.Fragment>
                ))}
            </dl>
            <span style={styles.span} onClick={() => disableBuildInfo()}>Close!</span>
        </div>
    );
};

export default BuildInfoEntry;
